export const PRICE_IVA = 1.1 // 10%
export const PRICE_IVA_ARREGLOS = 1.21 // 10%
export const PRICE_DECIMAL = 2 // 2 decimals

export const FORMAT_DATE = 'dd-MM-yyyy'
export const FORMAT_SERVER_DATE = 'yyyy-MM-dd'
export const FORMAT_TIME = 'dd-MM-yyyy : HH:mm'
